<script>
export default {
    methods: {
        getStyle(col, type) {
            const styles = {
                ...col[`${type}_style`],
                width: col.width,
            };

            return Object.entries(styles)
                .reduce(
                    (style, [name, value]) => style.concat(`${name}: ${value}`),
                    [],
                )
                .join(';');
        },
    },
};
</script>
